module.exports = __webpack_public_path__ + "static/img/baoxian2.29333039.png";